import {
  Button,
  CircularProgress,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  TextField,
  Typography,
} from '@material-ui/core';
import {getCaseAgentNumbersByCaseNumber, updateCaseAgentNumber} from 'BOSTools/ducks/bosTools';
import {CaseAgentNumber} from 'BOSTools/models/CaseAgentNumber';
import {isLoaded, ServerError} from 'Core/models/Async';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import './BOSTools.sass';

const CaseAgentNumberUpdate = () => {
  const dispatch = useDispatch();

  const {caseAgentNumbers} = useSelector((state: ReducerState) => state.bostools);
  const [caseNumber, setCaseNumber] = useState(isLoaded(caseAgentNumbers) ? caseAgentNumbers.Data[0]?.caseNumber : '');
  const [selectedCaseAgentNumber, setSelectedCaseAgentNumber] = useState<CaseAgentNumber>();

  useEffect(() => {
    if (isLoaded(caseAgentNumbers) && caseAgentNumbers.Data.length === 1) {
      setSelectedCaseAgentNumber(caseAgentNumbers.Data[0]);
    }
  }, [caseAgentNumbers]);

  return (
    <Grid container direction="column" spacing={4}>
      <>
        <Grid item>
          <TextField
            id="caseNumber"
            fullWidth
            variant="outlined"
            label="Case Number"
            value={caseNumber}
            onChange={e => setCaseNumber(e.target.value)}
            required
          />
        </Grid>
        <Grid item container justify="flex-end">
          <Button
            color="primary"
            variant="contained"
            disabled={!caseNumber}
            onClick={() => {
              dispatch(getCaseAgentNumbersByCaseNumber(caseNumber!));
              setSelectedCaseAgentNumber(undefined);
            }}
          >
            Search
          </Button>
        </Grid>
        {isLoaded(caseAgentNumbers) ? (
          selectedCaseAgentNumber ? (
            <>
              <Grid item>
                <TextField
                  id="caseNumber"
                  fullWidth
                  variant="outlined"
                  label="Case Number"
                  value={selectedCaseAgentNumber.caseNumber || ''}
                  disabled
                />
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="SA Number"
                  required
                  inputProps={{
                    maxLength: 10,
                  }}
                  value={selectedCaseAgentNumber.servicingAgentNumber || ''}
                  onChange={e =>
                    setSelectedCaseAgentNumber({...selectedCaseAgentNumber, servicingAgentNumber: e.target.value})
                  }
                />
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="AOR Number"
                  required
                  inputProps={{
                    maxLength: 10,
                  }}
                  value={selectedCaseAgentNumber.agentOfRecordNumber || ''}
                  onChange={e =>
                    setSelectedCaseAgentNumber({...selectedCaseAgentNumber, agentOfRecordNumber: e.target.value})
                  }
                />
              </Grid>
              <Grid item container justify="flex-end">
                <Button
                  color="primary"
                  variant="contained"
                  disabled={
                    !selectedCaseAgentNumber.servicingAgentNumber || !selectedCaseAgentNumber.agentOfRecordNumber
                  }
                  onClick={() => dispatch(updateCaseAgentNumber(selectedCaseAgentNumber))}
                >
                  Update
                </Button>
              </Grid>
            </>
          ) : (
            <List
              subheader={
                <ListSubheader component="div" disableSticky>
                  Please Choose An Item From The List To Update
                </ListSubheader>
              }
            >
              <Divider component="hr" />
              {caseAgentNumbers.Data.map(can => (
                <ListItem key={can.caseID} button onClick={() => setSelectedCaseAgentNumber(can)}>
                  <ListItemText
                    primary={
                      <Grid container>
                        <Grid item className="bostools_right_margin">
                          <Typography>SA Number: {can.servicingAgentNumber}</Typography>
                        </Grid>
                        <Grid item>
                          <Typography>AOR Number: {can.agentOfRecordNumber}</Typography>
                        </Grid>
                      </Grid>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )
        ) : caseAgentNumbers.key === 'Loading' ? (
          <div className="bostools_form__loading-container">
            <CircularProgress color="primary" />
          </div>
        ) : (
          ['ServerError', 'NotFound'].includes(caseAgentNumbers.key) && (
            <Grid item>
              <Typography variant="body1">
                {(caseAgentNumbers as ServerError).errorDetails || (caseAgentNumbers as ServerError).message}
              </Typography>
            </Grid>
          )
        )}
      </>
    </Grid>
  );
};

export default CaseAgentNumberUpdate;
